import ErrorMessage from "../commons/ErrorMessage"
import PageTitle from "../commons/PageTitle"

function PageLayout({
    pageTitle = "PageTitle",
    isError = false,
    errorMsg = null,
    isLoadingPage = false,
    isLoadingContent = false,
    onPageRefresh = null,
    bodyContent = null
}) {

    // console.log(`${pageTitle} page RENDERED - Loading:${isLoadingPage || isLoadingContent}`)
    return (
        <>
            <div className="container px-4 mt-4">
                <PageTitle title={pageTitle} onRefresh={onPageRefresh} isLoading={isLoadingPage || isLoadingContent} />
                {
                    isError &&
                    <ErrorMessage error={errorMsg}/>
                }
                {
                    isLoadingPage != true &&
                    <div className={`mb-4 ${isLoadingContent ? "opacity-25" : ""}`}>{bodyContent}</div>
                }
            </div>
        </>
    )

}

export default PageLayout